import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {PatientDataModel} from '../../models/patient/patient-data.model';
import {PatientInsuranceCoverageDataModel} from '../../models/patient/patient-insurance-coverage-data.model';
import {ConfigInsurancePayerIdModel} from '../../models/insurance/config-insurance-payer-id.model';
import {OrganizationDataModel} from '../../models/organization/organization-data.model';
import {ContactDataModel} from '../../models/person/contact-data.model';
import {PatientInsuranceDataModel} from '../../models/patient/patient-insurance-data.model';
import {InsuranceDataModel} from '../../models/insurance/insurance-data.model';
import {InsuranceDataSearchModel} from '../../models/insurance/insurance-data-search.model';
import {PatientInsuranceListViewDataModel} from './models/patient-insurance-list-view-data-view.model';
import {InsuranceCompanySearchResults} from './models/insurance-company-search-results';
import {dataARClaim, dataFeeScheduleDoctor, dataPatientInsurance} from '../ar/_models/ar.models';
import {DataARClaimModel} from '../../models/accountsReceivable/data-ar-claim.model';
import {FeeVariablesModel} from '../ar/models/ar-fee-variables.model';
import {DentalXChangeRTBRequestModel} from '../../models/accountsReceivable/dentalxchange-rtb-request.model';
import {TdoClientConfigurationModel} from '../../models/clients/tdo-client-configuration.model';
import {
    PatientInsuranceCoverageListViewModel,
    PatientInsuranceCoverageSaveModel
} from './models/patient-insurance-coverage-list-view.model';
import {ConfigInsurancePayerIdModelFrontEnd} from '../configuration/models/config-insurance-payer-id-frontend';
import {FeeScheduleDataModel} from '../../models/fee-schedule/fee-schedule-data.model';
import {Constants} from '../../constants';
import {ValidationResult} from '../ar/models/ValidationResult.model';
import {CfgClaimStatusCodeByApiVendor} from '../ar/models/cfg-claim-status-code-by-api-vendor';

@Injectable({
    providedIn: 'root'
})
export class InsuranceService {

    constructor(
        private http: HttpClient
    ) { }



    getClaimProcessorParamas(enumARClaimProcessorID: string, Topics: string ): Observable<any> {
        return this.http.get<any>(`api/insurance/get-claim-processor-params/${enumARClaimProcessorID}/${Topics}`);
    }

    saveClaimProcessorParams(param: any): Observable<any> // ClaimProcessorParamas
    {
        return this.http.post<any>('api/insurance/save-claim-processor-param', param);
    }



    getInsuranceProfile(PatientInsuranceID: string): Observable<any> {
        return this.http.get<any>(`api/insurance/get-patient-insurance-profile/${PatientInsuranceID}`);
    }


    savePayerRecord( p: ConfigInsurancePayerIdModel): Observable<any> {

        return this.http.get<any>(`api/insurance/save-payer-record/${p.PayerID}/${p.Oragnization}/${p.PayerIDperNEIC}/${p.xauditDeleted}`);

    }
    saveInsuranceProfile(InsuranceID: string, PayerID: string, FeeScheduleID: string, EmployerNO: string, GroupNO: string ): Observable<any> {

        const param = {InsuranceID, PayerID, FeeScheduleID, EmployerNO, GroupNO};

        return this.http.post<any>('api/insurance/save-update-insurance-profile', param);


    // return this.http.get<any>(`api/insurance/get-update-insurance-profile/${InsuranceID}/${PayerID}/${FeeScheduleID}/${EmployerNO}/${GroupNO}`);
    }

    savePatientFeeScheduleOverWriteClear(PatientId: string ): Observable<any> {
        return this.http.get<any>(`api/insurance/get-save-clear-patientfeesched-overwrite/${PatientId}`);
    }


    getFeeSchedules():  Observable<any> {
        return this.http.get<any>('api/insurance/get-fee-schedules');

    }


    // api/accountReceivable/get-practice-default-feescheduleid
    getPracticeDefaultFeeScheduleID(TDOCID: string): Observable<string> {
        return this.http.get<string>(`api/accountReceivable/get-practice-default-feescheduleid/${TDOCID}`);
    }

    getPatientInsuranceInformation(dataPatientId: string): Observable<PatientDataModel> {
        return this.http.get<PatientDataModel>(`/api/insurance/getDataPatient/${dataPatientId}`);
    }

    getPatientInsuranceList(dataPatientId: string): Observable<PatientInsuranceListViewDataModel[]> {
        return this.http.get<PatientInsuranceListViewDataModel[]>(`/api/insurance/getDataPatientInsuranceList/${dataPatientId}`);
    }

    getPatientInsuranceCoverage(dataPatientInsuranceId: string): Observable<PatientInsuranceCoverageDataModel> {
        return this.http.get<PatientInsuranceCoverageDataModel>(`api/insurance/get-data-patient-coverage/${dataPatientInsuranceId}`);
    }

    getPatientInsuranceByPatientId(patientId: string): Observable<PatientInsuranceDataModel[]> {
        return this.http.get<PatientInsuranceDataModel[]>(`/api/insurance/get-patient-insurance-by-patient-id/${patientId}`);
    }

    saveSubscriberContact(dataContact: ContactDataModel): Observable<ContactDataModel> {
        return this.http.post<ContactDataModel>('/api/insurance/saveSubscriberContact', dataContact);
    }

    savePatientIsNoInsurance(PatientId: string , isNoInsurance: boolean) {

        console.log('calling savePatientIsNoInsurance');

        let z: any;

        try {
            z = this.http.get<string>(`/api/insurance/savePatientIsNoInsurance/${PatientId}/${isNoInsurance}`);
            console.log('data', z);

        }
        catch (error) {
            console.log(error);
        }

        return z;

    }


    getSubscriberContactByContactId(contactId: string) {
        return this.http.get<ContactDataModel>(`/api/Patient/getContactById/${contactId}`);
    }

    searchForDataContact(searchTerm: string): Observable<ContactDataModel[]> {
        return this.http.post<ContactDataModel[]>('/api/insurance/searchForDataContact', { searchTerm });
    }

    getFeeScheduleIDByOrganizationId(organizationID: string) {
        return this.http.get<string>(`/api/insurance/get-feescheduleid-by-organization/${organizationID}`);
    }

    updateDataPatientInsurance(dataPatientInsurance: PatientInsuranceDataModel, enumPatientContactTypeID: string = Constants.emptyGuid): Observable<PatientInsuranceDataModel> {
        console.log('updateDataPatientInsurance', dataPatientInsurance);
        return this.http.post<PatientInsuranceDataModel>(`/api/insurance/updateDataPatientInsurance/${enumPatientContactTypeID}`, dataPatientInsurance);
    }

    setPatientInsuranceToDefault(patientId: string): Observable<PatientInsuranceListViewDataModel> {
        return this.http.post<PatientInsuranceListViewDataModel>(`/api/insurance/setPatientInsuranceToDefault/${patientId}`, {});
    }

    getDoctorFeesForCodes(DoctorId: string, FeeScheduleId: string, CodeList: string[]): Observable<dataFeeScheduleDoctor[]> {
        return this.http.post<dataFeeScheduleDoctor[]>(`/api/accountReceivable/getDoctorFeesForCodes/${DoctorId}/${FeeScheduleId}`, CodeList);
    }

    deleteDataPatientInsurance(dataPatientInsurance: PatientInsuranceDataModel): Observable<PatientInsuranceDataModel> {
        return this.http.post<PatientInsuranceDataModel>('/api/insurance/deleteDataPatientInsurance', dataPatientInsurance);
    }

    // createDataPatientInsurance(dataPatientInsurance): Observable<any> {
    //  const httpOptions = {
    //    headers: new HttpHeaders({
    //      "Content-Type": "application/json"
    //    })
    //  };
    //  return this.http.post<any>(`/api/insurance/createDataPatientInsurance`, dataPatientInsurance, httpOptions);
    // }

    createDataInsurance(dataInsurance: InsuranceDataModel): Observable<InsuranceDataModel> {
        return this.http.post<InsuranceDataModel>('/api/insurance/createDataInsurance', dataInsurance);
    }

    searchForCarrier(searchTerm: string): Observable<InsuranceDataModel> {
        return this.http.post<InsuranceDataModel>('/api/insurance/searchForCarrier', { searchTerm });
    }

    searchForDataInsurance(searchObj: InsuranceDataSearchModel): Observable<InsuranceCompanySearchResults[]> {
        return this.http.post<InsuranceCompanySearchResults[]>('/api/insurance/searchForDataInsurance', searchObj);
    }

    searchForDataInsuranceExists(searchObj: InsuranceDataSearchModel): Observable<InsuranceCompanySearchResults[]> {
        return this.http.post<InsuranceCompanySearchResults[]>('/api/insurance/searchForDataInsuranceExists', searchObj);
    }

    createDataPatientInsurance(dataPatientInsurance: PatientInsuranceDataModel): Observable<PatientInsuranceDataModel> {
        return this.http.post<PatientInsuranceDataModel>('/api/insurance/createDataPatientInsurance', dataPatientInsurance);
    }

    removeDataPatientInsurance(dataPatientInsuranceId: string): Observable<PatientInsuranceDataModel> {
        return this.http.post<PatientInsuranceDataModel>(`/api/insurance/removeDataPatientInsurance/${dataPatientInsuranceId}`, {});
    }

    createInsurancePayer(): Observable<ConfigInsurancePayerIdModelFrontEnd> {
        return this.http.post<ConfigInsurancePayerIdModelFrontEnd>('/api/insurance/create-insurance-payer', {});
    }

    saveInsurancePayers(payers: ConfigInsurancePayerIdModelFrontEnd[]): Observable<ConfigInsurancePayerIdModel[]> {
        return this.http.post<ConfigInsurancePayerIdModel[]>('/api/insurance/save-insurance-payers', payers);
    }

    getAllInsurancePayers(): Observable<ConfigInsurancePayerIdModel[]> {
        return this.http.get<ConfigInsurancePayerIdModel[]>('/api/insurance/getAllInsurancePayers');
    }

    saveInsurancePayer(payer: ConfigInsurancePayerIdModel) {


    }


    getAllInsurancePayersFrontEnd(): Observable<ConfigInsurancePayerIdModelFrontEnd[]> {
        return this.http.get<ConfigInsurancePayerIdModelFrontEnd[]>('/api/insurance/getAllInsurancePayers');
    }

    // getAllOrganizations(): Observable<OrganizationDataModel[]> {
    //   return this.http.get<OrganizationDataModel[]>('/api/insurance/getAllOrganizations');
    // }

    getAllOrganizations(): Observable<OrganizationDataModel[]> {
        return this.http.get<OrganizationDataModel[]>('/api/insurance/getAllOrganizations');
    }

    getAllOrganizationsByType(enumOrganizationTypeId: string): Observable<OrganizationDataModel[]> {
        return this.http.get<OrganizationDataModel[]>(`/api/insurance/get-organizations-by-type/${enumOrganizationTypeId}`);
    }

    getDataCoveragesForInsurance(dataInsuranceID): Observable<PatientInsuranceCoverageDataModel[]> {
        return this.http.get<PatientInsuranceCoverageDataModel[]>(`/api/insurance/getDataCoveragesForInsurance/${dataInsuranceID}`);
    }

    getPatientInsuranceCoveragesForInsurance(InsuranceID): Observable<PatientInsuranceCoverageListViewModel[]> {
        return this.http.get<PatientInsuranceCoverageListViewModel[]>(`/api/insurance/get-patient-insurance-coverages-for-insurance/${InsuranceID}`);
    }

    getPatientInsuranceCoveragesForInsuranceApplyDisc(InsuranceID: string , DiscountA: number, DiscountB: number, DiscountC: number ): Observable<any> {
        return this.http.get<any>(`/api/insurance/get-patient-insurance-coverages-for-insurance-apply-discounts/${InsuranceID}/${DiscountA}/${DiscountB}/${DiscountC}`);
    }

    savePatientInsuranceCoveragesForInsurance(covs: PatientInsuranceCoverageSaveModel[]): Observable<string[]> {
        return this.http.post<any>('/api/insurance/post-patient-insurance-coverages-for-insurance', covs);
    }

    getPatientClaims(PatientId: string): Observable<DataARClaimModel[]> {
        return this.http.get<DataARClaimModel[]>(`/api/accountReceivable/getPatientClaims/${PatientId}`);
    }

    getTDOClient(): Observable<TdoClientConfigurationModel> {
        return this.http.get<TdoClientConfigurationModel>('/api/ClientOfficeLocationConfiguration/getTDOClient');
    }

    getPatientInsuranceDetails(PatientID: string): Observable<dataPatientInsurance[]> {
        return this.http.get<dataPatientInsurance[]>(`/api/insurance/get-patient-insurance-details/${PatientID}`);
    }

    // getRTBResponse(): Observable<any> {
    //   return this.http.get<any>('/api/insurance/getRTBResponse');
    // }

    postRTBRequest(request: DentalXChangeRTBRequestModel): Observable<any> {
        return this.http.post<any>('/api/insurance/postRTBRequest', request);
    }

    getRTBResponse(patientInsuranceId: string, providerDoctorId: string): Observable<any> {
        return this.http.get<any>(`/api/insurance/get-rtb-response/${patientInsuranceId}/${providerDoctorId}`);
    }

    getDXClaimStatusResult(ARClaimID: string): Observable<any> {
        return this.http.get<any>(`api/insurance/get-dx-claim-status-response/${ARClaimID}`);
    }

    getX12ClaimStatusCodes(): Observable<CfgClaimStatusCodeByApiVendor[]> {
        return this.http.get<CfgClaimStatusCodeByApiVendor[]>('api/insurance/get-x12-claim-status-codes');
    }
}
